export const linkClasses = `
    grid grid-cols-[1.25rem_1fr] items-center gap-2 px-4 py-2 rounded-lg
    text-text-alternative hover:text-text-default hover:bg-background-default-hover
    transition-colors duration-200
    `
